import { useAct } from 'DashboardBuilder/store'
import AddIcon from '@material-ui/icons/Add'
import BackdropModal from 'Shared/components/BackdropModal/BackdropModal'
import FieldMap from '../../../FieldMap'
import './styles/AddField.scoped.scss'

export default function AddField() {
  const act = useAct()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedFieldType, setSelectedFieldType] = useState('')
  const [fieldName, setFieldName] = useState('')

  function toggleModal({ open = null } = {}) {
    const newOpenState = open === null ? !isModalOpen : open

    setIsModalOpen(newOpenState)

    if (!newOpenState || open === true) {
      setFieldName('')
      setSelectedFieldType('')
    }
  }

  function handleAddField() {
    if (!selectedFieldType || !fieldName.trim()) {
      return
    }
    const selectedField = FieldMap.find(field => field.source === selectedFieldType)
    act.dashboardFields.add({
      name: fieldName.trim(),
      source: selectedFieldType,
      ...Object.fromEntries(selectedField.requiredFields.map(field => [field, null])) // todo: test
    })
    toggleModal({ open: false })
  }

  return (
    <>
      <button className="button primary" onClick={() => toggleModal({ open: true })}>
        <AddIcon /> Add Column
      </button>

      <BackdropModal
        open={isModalOpen}
        title="Add New Column"
        onCancel={() => toggleModal({ open: false })}
        maxWidth="sm"
      >
        <div className="add-field-modal-content">
          <div className="field">
            <label>Column Name</label>
            <input
              type="text"
              value={fieldName}
              onChange={(e) => setFieldName(e.target.value)}
              placeholder="Enter column name"
            />
          </div>

          <div className="field">
            <label>Field Type</label>
            <select
              value={selectedFieldType}
              onChange={(e) => setSelectedFieldType(e.target.value)}
            >
              <option value="">Select field type</option>
              {FieldMap.filter(fieldType => !fieldType.hiddenOnSelectedField?.(null)).map((fieldType) => (
                <option key={fieldType.source} value={fieldType.source}>
                  {fieldType.label}
                </option>
              ))}
            </select>
          </div>

          <div className="add-field-modal-buttons margin-top double">
            <button
              className="button primary"
              onClick={handleAddField}
              disabled={!selectedFieldType || !fieldName.trim()}
            >
              Add Column
            </button>
            <button className="button secondary" onClick={() => toggleModal({ open: false })}>Cancel</button>
          </div>
        </div>
      </BackdropModal>
    </>
  )
}
